import localforage from 'localforage';
import Security from './Security';

let derniereDeconnexion = 0;

// Le token OAuth vit 420 jours mais tryRefreshProfil prolonge la session
// locale tant qu'il répond : un technicien qui ne se reconnecte jamais finit
// par tomber sur un token expiré et tous ses appels API répondent 401.
// Seul le refus OAuth (`invalid_grant`) compte : certains endpoints métier
// renvoient aussi un 401 « Acces denied! » avec un token valide.
export function estSessionExpiree(err) {
    const reponse = err && err.response;

    return !!(reponse && reponse.status === 401 && reponse.data && reponse.data.error === 'invalid_grant');
}

// Un 401 arrivé en retard (requête partie avec l'ancien token) ne doit pas
// purger le token obtenu entre-temps par une reconnexion. Sans token (login
// hors-ligne après une expiration), il faut aussi renvoyer au login en ligne.
function tokenEncoreCourant(err) {
    const entete = err.config && err.config.headers && err.config.headers.Authorization;

    return localforage.getItem('api-token').then(token => !token || entete === 'Bearer ' + token);
}

// Redirection avant l'alerte : sweetalert2 6.x ne résout jamais la promesse
// d'une alerte remplacée par un autre swal(), l'utilisateur resterait bloqué.
// `offlineActions`, `profil` et `pwd` sont conservés : la file hors-ligne doit
// partir après la reconnexion.
function deconnecterSessionExpiree(err) {
    tokenEncoreCourant(err).then(courant => {
        // Les requêtes parallèles d'un même écran échouent ensemble : une seule alerte.
        if (!courant || Date.now() - derniereDeconnexion < 5000) {
            return;
        }
        derniereDeconnexion = Date.now();

        new Security().logout(() => {
            window.location.hash = '#/login';
            swal('Session expirée', 'Votre session a expiré, merci de vous reconnecter.', 'warning').catch(() => {});
        });
    }).catch(() => {});
}

export function surveillerSessionExpiree(api) {
    api.interceptors.response.use(null, err => {
        if (estSessionExpiree(err)) {
            deconnecterSessionExpiree(err);
        }

        return Promise.reject(err);
    });

    return api;
}



// WEBPACK FOOTER //
// ./src/js/core/SessionExpiree.js